import { type FireAnalyticsEvent } from '../../types';
import { getEnvironment } from '../get-environment';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type commonAndPrivateAttributesType = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	cloudId?: string;
};

export const onQueryIntentFailure = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	cloudId,
}: commonAndPrivateAttributesType): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'failed',
	attributes: {
		commonAttributes,
		environment: getEnvironment(cloudId),
	},
	nonPrivacySafeAttributes,
});

export const onQueryIntentReturned = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	cloudId,
	queryIntentClassification,
}: commonAndPrivateAttributesType & { queryIntentClassification: string }): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'returned',
	attributes: {
		commonAttributes,
		additionalAttributes: {
			environment: getEnvironment(cloudId),
			queryIntentClassification,
		},
	},
	nonPrivacySafeAttributes,
});

export const onQueryIntentFired = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: commonAndPrivateAttributesType): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'fired',
	attributes: {
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
